import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import routes from './routes';
import store from '../store';

const whiteList = ['/login', '/wechatlogin', '/findpassword', '/resetpassword', '/bindaccount', '/device/maps']; // no redirect whitelist

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

const routerRoutes = router.getRoutes();

router.beforeEach(async (to, from, next) => {
  // 刷新处理
  const isRedirect = to.path.startsWith('/redirect');
  if (isRedirect) {
    const includeList = store.state.vm.includeList;
    const route = routerRoutes.find(t => `/redirect${t.path}` === to.path);
    const keep = route && route.meta && route.meta.keep;
    if (!keep || !includeList.includes(keep)) {
      // 重定向路由
      next({ path: to.fullPath.replace('/redirect', ''), replace: true });
      return;
    }
    store.commit(
      'INCLUDELIST',
      includeList.filter(t => t !== keep)
    );
  }
  // 缓存处理
  if (to.meta.keep) {
    const includeList = store.state.vm.includeList;
    const isHas = includeList.includes(to.meta.keep);
    if (!isHas) {
      store.commit('INCLUDELIST', [...includeList, to.meta.keep]);
    }
  }
  // 登录权限
  if (whiteList.includes(to.path)) {
    next();
    return;
  }
  // 验证是否登录
  if (Cookies.get('token')) {
    next();
    return;
  }
  // 以上都不满足，跳转登录页
  next({ path: '/login' });
});

router.afterEach(() => {});

export default router;
